/*proj4/lib/common/sign*/
function _(require, module, exports) {
    module.exports = function (x) {
        return x < 0 ? -1 : 1;
    };
}